// src/helpers/persistKeys.js
export const PERSIST_KEYS = [
    'imprintMethod',
    'imprintLocation',
    'selectedColors',
    'selectedImprint',
    'selectedSizes',
    'customQty',
    'specialPrice',
    'imprintStep',
    'prices',
    'imprintKey',
    'sizesQty',
    'colorSizeLines',
    'totalSizesQty',
    'selectedColorsList',
    'selectedLastStep',
    'imprintMessageColorLines',
    // check
    // 'calendar',     // тільки якщо поки що НЕ робимо pick-поля (див. варіант B)
    //'mainVariantId', // if not receive from DOM after reload
];

// format value to Plain data ( not Vue Proxy )
// serialize array key => value.
/*
function toPlain(val) {
    if (Array.isArray(val)) {
        // save not number array keys:
        const namedKeys = Object.keys(val).filter(k => !Number.isInteger(+k));
        if (namedKeys.length) {
          const out = {};
          for (const k of namedKeys) out[k] = val[k];
          return out;
        }
        // array with number index not format
        return val.slice();
    }
    if (val && typeof val === 'object') {
        // object: to Plain
        const out = {};
        for (const k of Object.keys(val)) out[k] = toPlain(val[k]);
        return out;
      }
    return val;
}
*/


export function makeSnapshot(store) {
    // перетворюємо «масиви з іменними ключами» у Plain Object,
    // інакше JSON.stringify відкине неіндексні ключі
    const toJSONSafe = (val) => {
        if (Array.isArray(val)) {
            // якщо це «чистий» масив (тільки індекси) — лишаємо як є
            const ownKeys = Object.keys(val); // включає і неіндексні
            const onlyIndexes = ownKeys.every(k => String(+k) === k);
            if (onlyIndexes) return val;
            // інакше збираємо у звичайний об'єкт разом із неіндексними властивостями
            const obj = {};
            for (const k in val) { obj[k] = toJSONSafe(val[k]); }
            return obj;
        } else if (val && typeof val === 'object') {
            const out = {};
            for (const k of Object.keys(val)) out[k] = toJSONSafe(val[k]);
            return out;
        }
        return val;
    };

    const plain = {};
    for (const k of PERSIST_KEYS) {
        if (k in store) plain[k] = toJSONSafe(store[k]);
    }

    return plain;
}

// ───────────── DEBUG HELPERS ─────────────
function typeOf(v){
    if (Array.isArray(v)) return 'array';
    if (v === null) return 'null';
    return typeof v; // 'object' | 'string' | 'number' | 'boolean' | 'undefined'
}

export function logSnapshotDebug(label, obj){
  try {
        const json = JSON.stringify(obj);
        const bytes = new Blob([json]).size;
        // зведена таблиця типів по whitelist-ключах
        const summary = {};
        for (const k of Object.keys(obj)){
              summary[k] = {
                        type: typeOf(obj[k]),
                        // короткий індикатор "наповненості"
                        sizeHint: typeOf(obj[k])==='string' ? obj[k].length :
                                typeOf(obj[k])==='array'  ? obj[k].length :
                                typeOf(obj[k])==='object' ? Object.keys(obj[k]||{}).length : ''
                          };
            }
        console.groupCollapsed(`🧪 [Persist] ${label} snapshot (${bytes} bytes)`);
        console.table(summary);
        console.log('raw:', obj);
        console.groupEnd();
      } catch(e) {
        console.warn('[Persist] logSnapshotDebug failed:', e);
      }
}
